/*
 * Copyright 2023 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import { ChatSupportProviderV1 } from "@startree-ui/platform-ui";
import React, { FunctionComponent } from "react";
import { isSaasUser } from "../../utils/user/user.util";
import { useUser } from "../user-provider/user-provider.component";
import { CustomerSupportProviderWrapperProps } from "./customer-support-provider-wrapper.interfaces";

const INTERCOM_APP_ID = "bxs433fe";

export const CustomerSupportProviderWrapper: FunctionComponent<CustomerSupportProviderWrapperProps> =
    ({ children }) => {
        const { user } = useUser();

        // add customer support for only saas trial users
        // null email means user is not authenticated or user information not fetched yet
        if (!!user?.email && isSaasUser(user)) {
            return (
                <ChatSupportProviderV1
                    appId={INTERCOM_APP_ID}
                    email={user.email}
                    nameOfUser={user.name}
                >
                    {children}
                </ChatSupportProviderV1>
            );
        }

        return <>{children}</>;
    };
